/**
 * RBAC 子权限名常量
 *
 * 权威来源：src/constants/rbacPages.json → buildRbacConstantsFromPages()
 * 值与后端 Seeder / middleware('permission:xxx')、GET /admin/permissions/tree 节点名一致
 *
 * 菜单、路由守卫、v-permission 均使用 apis[].name（第二级），不可用 module 父级名
 */
import { buildRbacConstantsFromPages } from './rbacPages'

/** 由 rbacPages.json 生成的常量映射 */
export const RBAC_FROM_PAGES = buildRbacConstantsFromPages()

/** 业务代码引用：RBAC.ACTIVITY_LIST → '查看活动列表' */
export const RBAC = Object.freeze({
  ...RBAC_FROM_PAGES,
  /** 对接人权限短名别名（module 前缀 REGISTRATION_） */
  PROXY_SUBMISSION_LIST: RBAC_FROM_PAGES.REGISTRATION_PROXY_SUBMISSION_LIST,
  PROXY_MEETING_LIST: RBAC_FROM_PAGES.REGISTRATION_PROXY_MEETING_LIST,
  PROXY_ENTRY: RBAC_FROM_PAGES.REGISTRATION_PROXY_ENTRY,
  PROXY_SUBMISSION_EDIT: RBAC_FROM_PAGES.REGISTRATION_PROXY_SUBMISSION_EDIT,
  /** H5 报名提交列表 / 审核（管理员与对接人共用 B 端 submissions 接口） */
  SUBMISSION_LIST: RBAC_FROM_PAGES.REGISTRATION_SUBMISSION_LIST,
  SUBMISSION_EDIT: RBAC_FROM_PAGES.REGISTRATION_SUBMISSION_EDIT,
  SUBMISSION_DELETE: RBAC_FROM_PAGES.REGISTRATION_SUBMISSION_DELETE,
  SUBMISSION_REVIEW: RBAC_FROM_PAGES.REGISTRATION_SUBMISSION_REVIEW,
  /** 报名订单（B 端建单 / 列表 / 详情 / 取消） */
  ORDER_CREATE: RBAC_FROM_PAGES.REGISTRATION_ORDER_CREATE,
  ORDER_LIST: RBAC_FROM_PAGES.REGISTRATION_ORDER_LIST,
  ORDER_VIEW: RBAC_FROM_PAGES.REGISTRATION_ORDER_VIEW,
  ORDER_CANCEL: RBAC_FROM_PAGES.REGISTRATION_ORDER_CANCEL,
  ORDER_PAY: RBAC_FROM_PAGES.REGISTRATION_ORDER_PAY,
  ORDER_PAY_STATUS: RBAC_FROM_PAGES.REGISTRATION_ORDER_PAY_STATUS,
  ORDER_REFUND: RBAC_FROM_PAGES.REGISTRATION_ORDER_REFUND
})
